module.exports = __webpack_public_path__ + "static/media/vu.d94609b9.webp";